/**
 * Returns true if the given notification is a Q&A notification.
 *
 * @param {object} notification The notification object to check.
 * @returns {boolean} Returns true if the notification is a Q&A notification, false otherwise.
 */
export function isQANotification(notification) {
    return !!notification.content?.data?.questionId;
}
